import React from 'react';

import { PriceText, FontColor } from '@prisjakt/ui/text/variants';
import Currency from '@prisjakt/ui-currency';

type Props = {
  isDeal: boolean;
  price: number;
  currency?: string;
};

export const Price = (props: Props) => {
  const { isDeal, price, currency } = props;

  return (
    <PriceText color={isDeal ? FontColor.NEGATIVE : FontColor.DARK}>
      <Currency price={price} code={currency} />
    </PriceText>
  );
};
